import React from 'react';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import { EmptorTag } from '../emptor_tag/EmptorTag';
import WarrantyDisplay from '../common/WarrantyDisplay';
import {
	checkIsWarrantyActive,
	getWarrantyStatus,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';
import { Button, Typography } from 'antd';
import OfflineTag from '../common/OfflineTag';
import { ArrowRightOutlined } from '@ant-design/icons';
import DateTimeHover from '../date_time_component/DateTime';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { canViewAssetLabels, PERMISSION_NAMES } from '../../utils/AuthUtils';
import LabelChip from '../StarLabels/LabelChip';
import { connect } from 'react-redux';

require('./AssetRowDisplay.less');
const { Text } = Typography;

const AssetRowDisplayComponent: React.FC<any> = ({
	asset,
	currentUser,
	userType,
	companyConfig,
	...props
}) => {
	const warrantyStatus = getWarrantyStatus(nullSafeGet('warranties.0', asset));
	const partWarranty = nullSafeGet('partWarranty', asset);
	const assetLabels = canViewAssetLabels(userType, companyConfig, currentUser)
		? nullSafeGetOrElse('assetLabels', asset, [])
		: [];

	return (
		<div className="assetRowDisplay" {...props}>
			<div className="flex flex-col gap-3">
				<div className="assetRowDisplay__rowTitle flex flex-row items-center">
					<Ellipsis tooltip={true} length={56}>
						{asset.name}
					</Ellipsis>
				</div>
				<div className="flex text-gray-500">
					<div className="mr-4">{`Asset ID ${asset.buyerSpecificAssetId || asset.id}`}</div>
				</div>
				<div className="flex items-center text-gray-500">
					<div className="mr-4 flex flex-shrink flex-row items-center gap-2">
						<span className="rowGrayChip">
							<i className="icons8-font icons8-location-marker mr-1" />
							<span>{nullSafeGet('location.name', asset)}</span>
						</span>
						{asset.nextScheduledTransfer ? (
							<div className="flex flex-shrink flex-row items-center gap-2">
								<ArrowRightOutlined />
								<span className="rowGrayChip">
									<i
										className={`icons8-font ${
											nullSafeGet('nextScheduledTransfer.state.location.name', asset)
												? 'icons8-location-marker'
												: 'icons8-warehouse-3'
										} mr-1`}
									/>
									<span>
										{nullSafeGetOrElse(
											'nextScheduledTransfer.state.location.name',
											asset,
											nullSafeGet('nextScheduledTransfer.state.stockLocation.name', asset)
										)}
									</span>
								</span>
								<span className="bodyregular ">
									Transfer Scheduled:{' '}
									<DateTimeHover
										showDate
										showTime
										timestamp={nullSafeGet('nextScheduledTransfer.triggerAt', asset)}
										timeZone={nullSafeGetOrElse(
											'nextScheduledTransfer.state.location.timeZoneId',
											asset,
											nullSafeGet('nextScheduledTransfer.state.stockLocation.timeZoneId', asset)
										)}
									/>
								</span>
							</div>
						) : null}
					</div>
					{asset.downtimeStatus === 'offline' ? (
						<div className="mr-4">
							<OfflineTag />
						</div>
					) : null}
					{assetLabels.length > 0 ? (
						<AccessPermissionChecker name={PERMISSION_NAMES.VIEW_ASSET_LABELS}>
							<div className="mr-4 flex flex-row flex-wrap items-center gap-2">
								{assetLabels.map((label) => (
									<LabelChip label={label} key={label.id} />
								))}
							</div>
						</AccessPermissionChecker>
					) : null}
					{checkIsWarrantyActive(nullSafeGet('warranties.0', asset)) ? (
						<div className="mr-4">{WarrantyDisplay(warrantyStatus, 'Service')}</div>
					) : null}
					{checkIsWarrantyActive(partWarranty) ? (
						<div className="mr-4">{WarrantyDisplay(getWarrantyStatus(partWarranty), 'Part')}</div>
					) : null}
					{asset.manufacturer ? <div className="mr-4">{asset.manufacturer}</div> : null}
					{asset.modelNumber ? <div className="mr-4">{asset.modelNumber}</div> : null}
					{asset.isActive ? null : (
						<div className="mr-4">
							<Text className={'mr-1'} type={'danger'}>
								Inactive
							</Text>
						</div>
					)}
				</div>
			</div>
			<div className="flex flex-row items-center group-hover:hidden">
				<div className="flex flex-col items-end gap-3">
					{asset.assetNumber && (
						<div className="flex text-gray-500 ">{`Asset Number ${asset.assetNumber}`}</div>
					)}
					<div className="uppercase text-gray-400">{nullSafeGet('assetType.name', asset)}</div>
					<EmptorTag className="assetRowDisplay__pill">
						{asset.totalNotClosedWOCount > 0
							? asset.totalNotClosedWOCount + ' Open WOs'
							: 'No Open WOs'}
					</EmptorTag>
				</div>
			</div>
		</div>
	);
};

// Connected only for the asset-label gate; no dispatch so it isn't spread onto the DOM node.
export const AssetRowDisplay = connect(
	(state: any) => ({
		currentUser: state.session.currentUser,
		userType: state.session.userType,
		companyConfig: state.company_config.detail,
	}),
	() => ({})
)(AssetRowDisplayComponent);
